import { SET_OPERATIONS, LOAD_OPERATIONS } from './types';

export function setOperationsAction(data) {
  return {
    type: SET_OPERATIONS,
    payload: data
  }
}

export function loadOperationsAction(queryParams) {
  return {
    type: LOAD_OPERATIONS,
    payload: queryParams
  }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/actions.js